import { render, staticRenderFns } from "./listaServicos.vue?vue&type=template&id=33ac787c&scoped=true&"
import script from "./listaServicos.vue?vue&type=script&lang=js&"
export * from "./listaServicos.vue?vue&type=script&lang=js&"
import style0 from "./listaServicos.vue?vue&type=style&index=0&id=33ac787c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ac787c",
  null
  
)

export default component.exports